// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2191":"b040afa6ad2625fb","5848":"3536d7052c14f24a","8073":"78da4eec31589e3c","8416":"60c1cfb6851e6f3d"}[chunkId] + ".css";
};